import React, {FC} from "react";

export interface Sectionbanner {
    className?: string;
    rightImg?: string;
}

const Sectionbanner: FC<Sectionbanner> = ({
                                              className = "",
                                          }) => {
    return (
        <div
            className={`text-center justify-center SectionTeam relative flex flex-col lg:flex-row items-center ${className}`}
            data-id="Sectionbanner"
        >
            <div className="text-center justify-center  ">
                <span className="text-center justify-center block mt-1 text-neutral-900 dark:text-neutral-100">
                                🎉 CryptoVerse is officially in Beta 🎉

        </span>
            </div>
        </div>
    );
};

export default Sectionbanner;

